export default () => ({
  filterPayload: {},
  filterModel: {}
});
